import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {IddTraining} from '../../../shared/interface/idd-training';
import {IddTrainingService} from '../../../shared/services/idd-training.service';
import {AddIddTrainingCertificateDialogComponent} from '../add-idd-training-certificate-dialog/add-idd-training-certificate-dialog.component';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {IddTrainingCertificate} from '../../../shared/interface/idd-training-certificate';
import {CertificateOverviewDialogComponent} from '../certificate-overview-dialog/certificate-overview-dialog.component';
import {
  ACTIVE_REGISTRATION_STATUSES,
  ARCHIVE_REGISTRATION_STATUSES,
  REGISTRATION_STATUS_REGISTERED, REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY
} from "../../../shared/services/dict.service";
import {
  RegistrationAddDialogComponent
} from "../../registrations/registration-add-dialog/registration-add-dialog.component";

@Component({
  selector: 'app-idd-training-details',
  templateUrl: './idd-training-details.component.html',
  styleUrls: ['./idd-training-details.component.scss']
})
export class IddTrainingDetailsComponent implements OnInit, OnDestroy {
  @Input() iddTrainings?: IddTraining;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  iddTrainingId: string;
  iddTrainingObject?: IddTraining;
  iddTraining: ReplaySubject<IddTraining> = new ReplaySubject<IddTraining>(1);
  modify = false;
  registrationsChanged: ReplaySubject<any> = new ReplaySubject<any>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  displayedColumns: string[] = ['meetingLeader', 'logo', 'insuranceCompany', 'realisedHours', 'aml', 'realisedAt', 'createdAt', 'createdBy', 'actions'];
  readonly ACTIVE_STATUSES = ACTIVE_REGISTRATION_STATUSES;
  readonly ARCHIVE_STATUSES = ARCHIVE_REGISTRATION_STATUSES;
  readonly REGISTRATION_STATUS_REGISTERED = REGISTRATION_STATUS_REGISTERED;
  readonly REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY = REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY;
  constructor(
    private route: ActivatedRoute,
    private iddTrainingService: IddTrainingService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.iddTrainingId = params.id;
        this.loadIddTraining();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadIddTraining(): void {
    this.iddTrainingService.get(this.iddTrainingId).subscribe((iddTraining: IddTraining) => {
      this.iddTraining.next(iddTraining);
      this.iddTrainingObject = iddTraining;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych szkolenia IDD', error.status.toString(), {
        duration: 2000
      });
    });
  }

  addCertificate(): void {
    const dialogRef = this.dialog.open(AddIddTrainingCertificateDialogComponent, {
      width: '70vw',
      height: '550px',
      autoFocus: false,
      data: {
        iddTrainingObject: this.iddTrainingObject,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadIddTraining();
    });
  }

  downloadCertificate(certificate: IddTrainingCertificate): void {
    this.iddTrainingService.downloadCertificate(certificate.uuid);
  }

  deleteCertificate(certificate: IddTrainingCertificate): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć zaświadczenie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.iddTrainingService.deleteCertificate(certificate.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto załącznik', '', {duration: 2000});
            this.loadIddTraining();
          });
      }
    });
  }

  downloadZip(): void {
    this.iddTrainingService.downloadCertificates(this.iddTrainingObject.uuid);
  }

  floor(num: number): number {
    return Math.floor(num);
  }

  certificateOverview(certificate: IddTrainingCertificate): void {
    this.dialog.open(CertificateOverviewDialogComponent, {
      width: '60vw',
      height: '90vh',
      autoFocus: false,
      data: {
        certificateId: certificate.uuid,
      },
    });
  }

  addRegistration(): void {
    const dialogRef = this.dialog.open(RegistrationAddDialogComponent, {
      width: '90vw',
      maxHeight: '90vh',
      data: {
        ofwcaObject: this.iddTrainingObject.ofwca,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.registrationsChanged.next(true);
    });
  }
}
